import { createVanIconComponent } from "./van"

const Success = createVanIconComponent("success")
export default Success
